import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LeadershipSection, {
  LeaderProfile,
  LeaderDetails,
} from "./LeaderShipContent";
import { leadershipData, otherLeaders } from "./LeadershipData";
import "./LeaderShip.css";

function PracticeLeaderShip() {
  return (
    <div>
      <LeadershipSection
        title={leadershipData.title}
        paragraph={leadershipData.paragraph}
        leaderName={leadershipData.leaderName}
        designation={leadershipData.designation}
        linkedinImg={leadershipData.linkedinImg}
        linkedinUrl={leadershipData.linkedinUrl}
        vectorClass={leadershipData.vectorClass}
        leaderImage={leadershipData.leaderImage}
      />

      <Container className="otherTeamSection">
        <Row>
          {otherLeaders.map((leader, index) => (
            <Col key={index} lg={true} className={leader.profileSectionClass}>
              <LeaderProfile
                imageSrc={leader.imageSrc}
                altText={leader.altText}
                placeholderText={leader.placeholderText}
              />
              <LeaderDetails
                name={leader.name}
                designation={leader.designation}
                linkedinImg={leader.linkedinImg}
                linkedinUrl={leader.linkedinUrl}
                playButtonImg={leader.playButtonImg}
              />
              <div className={leader.vectorClass}></div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default PracticeLeaderShip;
